export default __webpack_public_path__ + "static/media/login_icon.db0ca0ec.png";